<template>
    <CompassDialog
        :visible.sync="showModal"
        :size="sizeModal"
        class="popup-third-form"
        @closed="$emit('close')"
    >
        <template slot="header">
            <div class="dialog__header">
                <div class="pabsolute">
                    <CompassIconButton icon="close" @click="$emit('close')" />
                </div>
            </div>
        </template>
        <template slot="default">
            <div class="dialog__default">
                <component
                    :is="`${localOptions.action}-third-form`"
                    :current="current"
                    :defaultValue="value"
                    :options="localOptions"
                    @close="$emit('close')"
                    @next="next"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import CreateThirdForm from 'vcomponents/forms/popups/CreateThirdForm.vue';
import SearchThirdForm from 'vcomponents/forms/popups/SearchThirdForm.vue';

export default {
    components: {
        SearchThirdForm,
        CreateThirdForm,
    },
    props: {
        current: {
            type: String,
            required: true,
        },
        defaultValue: {
            type: [Object, String],
            required: false,
            default: '',
        },
        options: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            showModal: true,
            value: null,
            opt: {},
            localOptions: null,
            fetchedDatas: null,
            popupWidth: 480,
        };
    },
    computed: {
        sizeModal() {
            return this.popupWidth === 720 ? 'medium' : 'small';
        },
    },
    created() {
        this.value = this.defaultValue;
        this.localOptions = this.options;
        if (this.localOptions.next && this.localOptions.action === 'search') {
            this.localOptions.disableCompassList = true;
            this.localOptions.disableCreate = true;
            this.popupWidth = 720;
        }
    },
    methods: {
        next(datas) {
            if (!_.isNil(datas)) {
                this.fetchedDatas = datas;
            }
            if (this.localOptions.next && this.localOptions.next !== this.localOptions.action) {
                this.popupWidth = 480;
                this.formatDatas(datas);
                this.localOptions.action = this.localOptions.next;
            } else {
                if (!_.isNil(this.fetchedDatas)) {
                    this.fetchCompaniesRelatedData(this.fetchedDatas);
                }
                if (this.localOptions.next && this.localOptions.next === 'create') {
                    this.$store.dispatch(`${this.current}/commitCompanyAddress`);
                }
                this.$emit('close');
            }
        },
        formatDatas(datas) {
            this.value = { name: datas.name };
            this.localOptions.types = {
                type: 'company',
                subType: 'prospect',
            };
        },
        fetchCompaniesRelatedData(datas) {
            this.$store.commit(`${this.current}/setLoading`, true);

            this.$store.dispatch(`${this.current}/commitSearchCompany`, datas);
            this.$store
                .dispatch(`${this.current}/fetchCompaniesList`, {
                    search: datas.name,
                    siretAllowed: false,
                })
                .then((datas) => {
                    this.$store.commit(
                        `${this.current}/setSuggestionCompaniesList`,
                        this.nameExistsList,
                    );
                    this.$store.commit(`${this.current}/setLoading`, false);
                    Push.success(this.$l10n.__('Les informations ont été ajoutées'));
                });
        },
    },
};
</script>
<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.popup-third-form {
    .dialog {
        &__header {
            display: flex;
        }

        &__default {
            padding-bottom: 24px;
        }
    }

    .el-form-item__error {
        position: relative;
    }
}
</style>
